
export enum POItemUnitEnum {
    KG = 'KG',
    TONNE = 'Tonne'
}